module.exports = __webpack_public_path__ + "static/_bowValleyLogo-d21561a5c00aabf2f435099058597e91.png";